import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "store/features/authorization/authorization.actions";
import { authorize } from "store/features/authorization/authorization.actions";
import { AuthorizationViewModel } from "api";

export type AuthorizationAction = ActionType<typeof actions>;

export type AuthorizationState = Readonly<{
    isAuthorized: boolean;
    isAuthorizing: boolean;
    authorizationToken: string | null;
    data: AuthorizationViewModel | null;
}>;

export const authorizationInitialState: AuthorizationState = {
    isAuthorized: false,
    isAuthorizing: true,
    authorizationToken: null,
    data: null,
};

export const authorizationReducer = createReducer<AuthorizationState, AuthorizationAction>(authorizationInitialState)
    .handleAction(authorize.request, (state) => {
        return {
            ...state,
            isAuthorized: false,
            isAuthorizing: true,
        };
    })
    .handleAction(authorize.success, (state, { payload }) => {
        return {
            ...state,
            isAuthorizing: false,
            isAuthorized: true,
            isTokenExpired: false,
            data: { ...payload },
        };
    })
    .handleAction(authorize.failure, (state) => {
        return {
            ...state,
            authorizationFailed: true,
            isAuthorized: false,
            isAuthorizing: false,
        };
    });
